import type { QueryClient } from '@tanstack/react-query'

import { installUnsavedChangesGuard } from '@/lib/browser/unsaved-changes-guard'
import {
  hasPendingWidgetConfig,
  subscribePendingWidgetConfig,
} from '@/service/runtime-health/pending-widget-config-registry'

export const WIDGET_WRITE_MUTATION_KEY = ['uiState', 'widgetWrite'] as const

export function installWidgetSaveGuard(target: EventTarget, queryClient: QueryClient) {
  const mutations = queryClient.getMutationCache()
  return installUnsavedChangesGuard(
    target,
    () =>
      hasPendingWidgetConfig() ||
      mutations.findAll({ mutationKey: WIDGET_WRITE_MUTATION_KEY, status: 'pending' }).length > 0,
    (listener) => {
      const unsubscribeConfig = subscribePendingWidgetConfig(listener)
      const unsubscribeMutations = mutations.subscribe(listener)
      return () => {
        unsubscribeConfig()
        unsubscribeMutations()
      }
    }
  )
}
